import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { m } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { Button, Container, Link, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets/illustrations';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  hasContent: PropTypes.bool,
  type: PropTypes.string,
  roles: PropTypes.arrayOf(PropTypes.string),
};

export default function RoleBasedGuard({ hasContent, roles, type, children }) {
  const { user, logout } = useAuthContext();
  const currentRole = user?.role; // admin;
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoutAndGoHome = () => {
    logout();
    navigate('/');
  };

  useEffect(() => {
    if (hasContent && user) {
      if (location.pathname.includes(user?.type)) {
        return;
      }
      console.log('Invalid access attempt by user type:', user?.type);
      // logout();
    }
  }, [hasContent, user, logout, location.pathname]);
  if (
    (typeof roles !== 'undefined' && !roles.includes(currentRole)) ||
    (typeof type !== 'undefined' && type !== user?.type) ||
    (location.pathname && !location.pathname.includes(user?.type))
  ) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: 'center', pt: 4 }}>
        <m.div variants={varBounce().in}>
          <Typography
            variant="h3"
            paragraph
            sx={{
              maxWidth: 480,
              mx: 'auto',
              color: 'text.primary',
            }}
          >
            Sei connesso come {user?.type}, questa rotta non è accessibile per te.
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            Non hai il permesso di accedere a questa pagina
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
        <m.div variants={varBounce().in}>
          <Button variant="contained" size="large" onClick={handleLogoutAndGoHome}>
            Torna a Casa
          </Button>
        </m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}
